module.exports = __webpack_public_path__ + "img/q3_2020.9eb75e09.png";